var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.667 9.00008C15.667 12.682 12.6822 15.6667 9.00033 15.6667C5.31843 15.6667 2.33366 12.682 2.33366 9.00008C2.33366 5.31818 5.31843 2.33341 9.00033 2.33341C12.6822 2.33341 15.667 5.31818 15.667 9.00008ZM17.3337 9.00008C17.3337 13.6025 13.6027 17.3334 9.00033 17.3334C4.39795 17.3334 0.666992 13.6025 0.666992 9.00008C0.666992 4.39771 4.39795 0.666748 9.00033 0.666748C13.6027 0.666748 17.3337 4.39771 17.3337 9.00008ZM12.5063 8.33934C12.8317 8.0139 12.8317 7.48626 12.5063 7.16083C12.1808 6.83539 11.6532 6.83539 11.3277 7.16083L8.20581 10.2828L7.12593 9.05562C6.82188 8.71011 6.29532 8.6765 5.94981 8.98055C5.60431 9.28459 5.5707 9.81116 5.87474 10.1567L7.54141 12.0506C7.69351 12.2234 7.91033 12.3257 8.14045 12.333C8.37056 12.3403 8.59346 12.2521 8.75626 12.0893L12.5063 8.33934Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChecked);
export default __webpack_public_path__ + "static/media/Circle-Checked.a88429764eeb32cbe7181e59e0258487.svg";
export { ForwardRef as ReactComponent };